import { app } from '../app';

class SimulatorResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    simulateManualLogin(companyId, appId, username, otp) {
        const url = `app/rest/admin/company/${companyId}/application/${appId}/manageapp/simulator/manual`;
        const params = {username, otp};
        return this.$http.get(url, {params}).then(({data}) => data);
    }
}

app.service('SimulatorResource', SimulatorResource);



// WEBPACK FOOTER //
// ./src/portal/rest/SimulatorResource.js